import { render, staticRenderFns } from "./SectionLinks.vue?vue&type=template&id=bc239aaa&scoped=true&"
import script from "./SectionLinks.vue?vue&type=script&lang=ts&"
export * from "./SectionLinks.vue?vue&type=script&lang=ts&"
import style0 from "./SectionLinks.vue?vue&type=style&index=0&id=bc239aaa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc239aaa",
  null
  
)

export default component.exports